<template>
  <section class="container mt-6">
    <div id="t-top" class="swiper-container t-top">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="iframe-wrap">
            <iframe
              class="mv"
              :src='`${youtubeBasicUrl}${topVideo.youtubeUrl}?modestbranding=1&rel=0`'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div id="t-thum" class="swiper-container t-thum mt-2">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="video in bottomVideos"
          :key="video.brandFilmId"
        >
          <!-- 눌린 썸네일에 active 클래스 넣어주세요 -->
          <img
            :src="video.thumbnailImageUrl"
            alt=""
            class="swiper-s-img pointer"
            @click="() => changeVideo(video.brandFilmId)"
          />
          <p class="mt-15 swiper-txt">
            {{ video.title.length > 40 ? video.title.substr(0, 39) + '...' : video.title }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import snsApi from '@/apis/sns';

export default {
  name: 'Film',
  props: {
    filmInfo: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    filmInfo: {
      deep: true,
      handler(v) {
        if (v.length > 0) {
          this.settingFilm();
        }
      },
    },
  },
  data() {
    return {
      topVideo: {},
      bottomVideos: [],
      youtubeBasicUrl: 'https://www.youtube.com/embed/',
    };
  },
  methods: {
    async changeVideo(num) {
      await snsApi.updateFilmReadCount(num);
      const idx = this.bottomVideos.findIndex((n) => n.brandFilmId === num);
      const temp = { ...this.bottomVideos[idx] };
      this.bottomVideos[idx] = this.topVideo;
      this.topVideo = temp;
    },
    settingFilm() {
      this.topVideo = { ...this.filmInfo[0] };
      this.bottomVideos = this.filmInfo.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.iframe-wrap{
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}
.mv {
  position: absolute;
  width: 100%;
  height: 100%;
  // height: 80rem;
  // @media (max-width: 1024px) {
  //   height: 57rem;
  // }
  // @media (max-width: 768px) {
  //   height: 42rem;
  // }
  // @media (max-width: 425px) {
  //   height: 27rem;
  // }
  // @media (max-width: 375px) {
  //   height: 24rem;
  // }
}
@media (max-width: $mobile-size) {
  .t-thum .swiper-wrapper {
    white-space: nowrap;
    overflow: auto;
    .swiper-slide {
      width: 42%;
      margin-right: 1rem;
      white-space: normal;
    }
  }
}
</style>
